export default __webpack_public_path__ + "static/media/button_0_release.e07267cc.png";